module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box",
    class: {
      '-day': _vm.turno === 'manha', '-night': _vm.turno === 'noite'
    }
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [(!_vm.mostrarRecuperacaoSenha) ? _c('div', [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(false) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    },
    attrs: {
      "value": true,
      "type": "warning"
    }
  }, [_vm._v("\n                    Esse portal está em fase de testes, qualquer informação exibida aqui não se refere a informações\n                    reais das pessoas envolvidas\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-form-item"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.login),
      expression: "form.login"
    }],
    ref: "login",
    attrs: {
      "type": "tel",
      "placeholder": "Matrícula"
    },
    domProps: {
      "value": (_vm.form.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "login", $event.target.value)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLogin($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-item"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    ref: "password",
    attrs: {
      "type": "password",
      "placeholder": "Senha"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLogin($event)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "login-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.botaoClicado || _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.onLogin
    }
  }, [_vm._v("\n                    Entrar\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "login-forget-password"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mostrarRecuperacaoSenha = true
      }
    }
  }, [_vm._v("\n                        Primeiro acesso/Esqueci minha senha\n                    ")])])], 1)]) : _vm._e(), _vm._v(" "), _c('recuperar-senha', {
    attrs: {
      "show": _vm.mostrarRecuperacaoSenha
    },
    on: {
      "update:show": function($event) {
        _vm.mostrarRecuperacaoSenha = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": _vm.isMobile().any() ? '90%' : '50%'
    },
    model: {
      value: (_vm.mostrarModalInicial),
      callback: function($$v) {
        _vm.mostrarModalInicial = $$v
      },
      expression: "mostrarModalInicial"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "mensagem-boas-vindas"
  }, [_c('h2', {
    staticClass: "titulo-boas-vindas"
  }, [_vm._v("Bem-vindo ao "), _c('strong', [_vm._v("Sou URCAMP")])]), _vm._v(" "), _c('h2', {
    staticClass: "titulo-boas-vindas -subtitulo"
  }, [_vm._v("Nosso portal foi repensando e reformulado")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "bloco1",
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "icone"
  }, [_c('i', {
    staticClass: "far fa-smile-beam"
  })]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_vm._v("\n                                Pensamos em você ao fazer esse novo portal\n                            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "bloco2",
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "icone"
  }, [_c('i', {
    staticClass: "fas fa-sitemap"
  })]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_vm._v("\n                                A nova estrutura facilita o acesso às suas informações mais importantes\n                            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "bloco3",
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "icone"
  }, [_c('i', {
    staticClass: "fas fa-user-graduate"
  })]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_vm._v("\n                                Seus horários, notas e frequência estão aqui também\n                            ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "bloco4",
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "icone"
  }, [_c('i', {
    staticClass: "far fa-thumbs-up"
  })]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_vm._v("\n                                Sua opinião é importante para nós. Sinta-se livre para entrar em contato conosco\n                                e melhorarmos cada vez mais o nosso portal\n                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "info",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalInicial = false;
        _vm.mostrarModalContato = true
      }
    }
  }, [_vm._v("Fale\n                    Conosco\n                ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalInicial = false
      }
    }
  }, [_vm._v("Acessar o portal")])], 1)], 1)], 1), _vm._v(" "), _c('formulario-contato', {
    attrs: {
      "mostrar": _vm.mostrarModalContato
    },
    on: {
      "update:mostrar": function($event) {
        _vm.mostrarModalContato = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('h2', {
    staticClass: "login-header-title"
  }, [_vm._v("SOU")]), _vm._v(" "), _c('figure', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "https://urcamp.edu.br/site/img/logos/logo-branco.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a95b49e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/login/components/Login.vue
// module id = 521
// module chunks = 2